import Entity from './entity'
import result from 'lodash/result'
import Color from './color'
import RA from 'ra-config'
import { getColorByKey } from '../config/colors'
import { slugify } from 'lib/string'

const { categoryList, factorList } = RA.app.factors

class Factor extends Entity {
  static defaults = {
    dataPoints: []
  }

  setup() {
    const category = categoryList.find(item => item.name === this.Category)
    const factor = factorList.find(item => item.name === this.Name)

    this.Color = this.getColor(factor.color)
    this.Key = slugify({ items: [this.Category, this.Name] })
    this.CategoryShortName = result(
      category,
      'shortName',
      this.Category.toUpperCase()
    )
    this.ShortName = result(factor, 'shortName', '')
    this.Label = `${this.Name} (${this.Category})`
  }

  getColor(key) {
    return new Color(getColorByKey(key))
  }
}

export default Factor



// WEBPACK FOOTER //
// ./src/entities/factor.js